import type { SaleItem } from "../models/Sale";
import type { PurchaseItem } from "../models/Purchase";
import type { ReturnHistory } from "../models/ReturnHistory";
export type ReturnLine = SaleItem | PurchaseItem;
export const actionStatus = (value: unknown): ReturnHistory["Status"] =>
  value === 1 || value === "1" || value === "Approve" ? "Approve" : value === 2 || value === "2" || value === "Decline" ? "Decline" : "Pending";
export const approvedQuantity = (line: ReturnLine) => Math.max(Number(line.ReturnQuantity || 0),
  (line.ReturnHistories ?? []).filter(h=>actionStatus(h.Status)==="Approve").reduce((s,h)=>s+Number(h.ReturnQuantity||0),0));
export function returnableQuantity(line: ReturnLine, editingCode?: string) {
  const pending = (line.ReturnHistories ?? []).filter(h=>actionStatus(h.Status)==="Pending" && h.Code!==editingCode).reduce((s,h)=>s+Number(h.ReturnQuantity||0),0);
  return Math.max(0, Number(line.Quantity)-approvedQuantity(line)-pending);
}
export function returnValue(line: ReturnLine, quantity: number) {
  const original = "UnitPrice" in line ? line.Quantity*line.UnitPrice-Number(line.DiscountAmount||0) : line.Amount;
  const approvedValue = (line.ReturnHistories??[]).filter(h=>actionStatus(h.Status)==="Approve").reduce((s,h)=>s+Number(h.Amount||0),0);
  const remaining = Math.max(0, original-approvedValue);
  if (quantity === line.Quantity-approvedQuantity(line)) return remaining;
  return Math.min(remaining, Math.round((original*quantity/line.Quantity+Number.EPSILON)*100)/100);
}
